import { useState } from 'react';
import { Button, Divider, Stack, Typography } from '@mui/material';
import { ConfirmDecisionDialog } from './confirm-decision-dialog';
import { ContentBox } from '@/components/shared/content-box';
import { DescriptionContent } from '@/packages/subsidy-management/components/description-content';
import type { DetailsProps } from '@/packages/subsidy-management/interfaces';

export const Description = ({ resourceApprovalsDetails }: DetailsProps) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const [decisionType, setDecisionType] = useState<
    'approved' | 'rejected' | ''
  >('');

  return (
    <ContentBox>
      <Typography variant="h2" mb={3} color="primary.dark">
        Descrição do item
      </Typography>
      <DescriptionContent resourceApprovalsDetails={resourceApprovalsDetails} />
      <Divider sx={{ my: 3 }} />
      <Stack direction="row" justifyContent="flex-end" gap={2}>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            setDecisionType('rejected');
            setDialogOpen(true);
          }}
        >
          Recusar item
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            setDecisionType('approved');
            setDialogOpen(true);
          }}
        >
          Aprovar item
        </Button>
      </Stack>
      {dialogOpen && decisionType && (
        <ConfirmDecisionDialog
          decision={decisionType}
          onClose={() => setDialogOpen(false)}
          id={resourceApprovalsDetails?.uuid || ''}
        />
      )}
    </ContentBox>
  );
};
